import Box from '@zenbusiness/zui/Box';
import DialogContent from '@zenbusiness/zui/DialogContent';
import { styled } from '@zenbusiness/zui/styles';
import Tab from '@zenbusiness/zui/Tab';
import TabList from '@zenbusiness/zui/TabList';

export const TabBoxStyled = styled(Box)(({ theme }) => ({
  borderBottom: '1px solid',
  borderColor: theme.palette.fixed.black
}));

export const DialogContentStyled = styled(DialogContent)(() => ({
  padding: '24px 0px !important'
}));

export const TabListStyled = styled(TabList)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.background.green.main,
    height: '4px'
  }
}));

export const TabStyled = styled(Tab)(({ theme }) => ({
  fontSize: '16px',
  color: theme.palette.text.tertiary,
  [theme.breakpoints.up('md')]: {
    fontSize: '22px'
  }
}));
